"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgUpDownChevronsSvg = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ fill: "currentColor", height: 19, width: 12, xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("clipPath", __assign({ id: "UpDownChevronsSVG_svg__a" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M0 0h12v18.825H0z" }) })), (0, jsx_runtime_1.jsx)("g", __assign({ clipPath: "url(#UpDownChevronsSVG_svg__a)" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M5.293 18.118a1 1 0 0 0 1.414 0l4.588-4.588a.998.998 0 1 0-1.412-1.41l-3.176 3.177a1 1 0 0 1-1.414 0L2.117 12.12A.998.998 0 1 0 .706 13.53zM6.707.707a1 1 0 0 0-1.414 0L.705 5.295a.998.998 0 1 0 1.412 1.411l3.176-3.178a1 1 0 0 1 1.414 0l3.176 3.178a.998.998 0 1 0 1.411-1.41z" }) }))] }))); };
exports.default = SvgUpDownChevronsSvg;
